import axios from "axios";
import mapHttpStatusToPageBlockTransportErrorCategory from "./mapHttpStatusToPageBlockTransportErrorCategory";
import { PageBlockTransportErrorCategory } from "./PageBlockTransportErrorCategory";
export default function readPageBlockTransportFailure(requestError) {
    if (axios.isCancel(requestError)) {
        return { status: "cancelled" };
    }
    const httpStatus = axios.isAxiosError(requestError) ? requestError.response?.status : undefined;
    if (httpStatus === undefined) {
        return { status: "error", category: PageBlockTransportErrorCategory.UNEXPECTED };
    }
    return { status: "error", category: mapHttpStatusToPageBlockTransportErrorCategory(httpStatus), httpStatus };
}
